//store/modules/auth.js
import axios from 'axios';
import store from '../index';
import router from '@/router';
import mixin from '@/mixins';


const state = {
    settings: null,
    searchFilters: null,
    locker: false,
    premiumSearchFilters: null,
    selectedPackageId: null,
    welcomeModal: false,
};
const getters = {
    getSettings: state => state.settings,
    getSearchFilters: state => state.searchFilters,
    getPremiumSearchFilters: state => state.premiumSearchFilters,
    getLocker: state => state.locker,
    getselectedPackageId: state => state.selectedPackageId,
    getWelcomeModal: state => state.welcomeModal
};

const actions = {
    async GetSettings({ commit, dispatch }, User) {
        try {
            const settings = await axios.get('contents')
            await commit('setSettings', settings.data.data)
        } catch (error) {
            await dispatch('errorAction', error.response.data.message, { root: true })
        }
    },
    getSelectedId({ commit }, id) {
        commit('setSelectedId',id)
    },
    getWelcomeModalHandler({ commit }, data) {
        commit('setWelcomeModal',data)
    },
    SearchFilters({ commit }, filters) {
        commit('setSearchFilters', filters)
    },
    PremiumSearchFilters({ commit }, filters) {
        commit('setPremiumSearchFilters', filters)
    },
    Locker({ commit }) {
        if(store.getters.StateUser.data.pincode_status){
            commit('setLocker');
            
        } else{
           
            // console.log('router' , router.currentRoute.path == '/straight/settings/ChangePinCode');
            if(router.currentRoute.path !== '/straight/settings/ChangePinCode'){
                router.push( { name: 'SelectedSetting', params: { type: router.currentRoute.params.type, setting: 'ChangePinCode' } })
            }
        }

    },
   
};
const mutations = {
    setWelcomeModal(state, data) {
        state.welcomeModal = data;
    },
    setSelectedId(state, id) {
        state.selectedPackageId = id;
    },
    setSettings(state, settings) {
        state.settings = settings
    },
    setSearchFilters(state, filters) {
        state.searchFilters = filters
    },
    setPremiumSearchFilters(state, filters) {
        state.premiumSearchFilters = filters
    },
    setLocker(state) {
    localStorage.setItem("locker_info", !state.locker);
        state.locker = !state.locker
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};